import { differenceInCalendarDays, parseISO, startOfDay } from 'date-fns';
import * as Yup from 'yup';

const expiresAtField = Yup.date()
  .typeError('Please select a valid date')
  .min(startOfDay(new Date()), 'Date of expiry cannot be in the past')
  .required('Date of expiry is required');

export const AddThirdPartyAccessSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(2, 'Name must be at least 2 characters')
    .required('Name is required'),
  email: Yup.string()
    .email('Please enter a valid email')
    .required('Contact email is required'),
  expiresAt: expiresAtField,
});

export type AddThirdPartyAccessDataType = Yup.InferType<
  typeof AddThirdPartyAccessSchema
>;

type InitialValues = {
  name: string;
  email: string;
  expiresAt: string;
};

export const AddThirdPartyAccessInitialValues: InitialValues = {
  name: '',
  email: '',
  expiresAt: '',
};

// Formik holds the date as a 'yyyy-MM-dd' string, not the Date Yup infers
export interface AddThirdPartyAccessInterface {
  name: string;
  email: string;
  expiresAt: string;
}

export interface ThirdPartyAccessInterface {
  id: string;
  partnerName: string;
  partnerEmail: string;
  status: string;
  expiresAt?: string;
}

export const RegenerateThirdPartyTokenSchema = Yup.object().shape({
  expiresAt: expiresAtField,
});

export const RegenerateThirdPartyTokenInitialValues: RegenerateThirdPartyTokenInterface =
{
  expiresAt: '',
};

// Formik holds the date as a 'yyyy-MM-dd' string, not the Date Yup infers
export interface RegenerateThirdPartyTokenInterface {
  expiresAt: string;
}

// Picking today still gives the key a full day
export const toExpirationDays = (expiresAt: string) =>
  Math.max(1, differenceInCalendarDays(parseISO(expiresAt), new Date()));

export interface RedeemedPartnerKeyInterface {
  plainKey: string;
  companyName: string;
  expiresAt: string;
}
